import type { User, UserRole } from "@/models/user";
import { apiGet, buildQueryString } from "../client";
import type { Datasource } from "../types";

export interface UserSearchParams {
  search?: string;
  role?: UserRole;
  include?: "loyalty_account";
  limit?: number;
}

export interface SearchUsersResponse {
  users: User[];
}

export async function searchUsers(
  params: UserSearchParams = {},
): Promise<Datasource.Response<SearchUsersResponse>> {
  const queryString = buildQueryString({
    search: params.search,
    role: params.role,
    include: params.include,
    limit: params.limit ?? 10,
  });

  return apiGet<Datasource.Response<SearchUsersResponse>>(`/users?${queryString}`);
}
